import React, { Component } from 'react';
import { appendAttachment } from '../../../utils/FormDataUtils';
import '../../../resources/AdminStandardPage.css';
import AuthenticationService from '../../../services/AuthenticationService';
import DeletePUGCertificates from '../../../components/Dialogs/DeleteDialog/DeleteDialog';
import AttachmentField from '../../../components/AttachmentField/AttachmentField';
import NotificationSystem from 'react-notification-system';
import NotificationSystemStyle from '../../../constants/NotificationSystemStyle';
import { draftDecisionsService } from '../../../services/DraftDecisionsService';
import ReactPaginate from 'react-paginate';
import archiveJson from '../../../resources/archiveYears.json';

class AdminDraftDecisions extends Component {
  constructor(props) {
    super(props);
    const currentYear = `${new Date().getFullYear()}`;
    const archiveYears = archiveJson || [];
    const hasCurrentYear = archiveYears.some(
      archiveYear => archiveYear.value === currentYear
    );

    this.state = {
      disabledDocument: false,
      newDraftDecision: {
        title: '',
        document: '',
        add_date: '',
        public_consultation: false
      },
      selectedArchiveYear: currentYear,
      archiveYears: hasCurrentYear
        ? archiveYears
        : [{ id: -1, name: currentYear, value: currentYear }, ...archiveYears],
      existingDraftDecisions: [],
      deleteDraftDecision: {
        openedDialog: false,
        deleteId: 0
      },
      pagination: {}
    };

    this.authentication = new AuthenticationService();
  }

  componentWillMount() {
    this.fetchDraftDecisions();
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  handlePageClick = selectedPage => {
    this.fetchDraftDecisions(selectedPage.selected + 1);
  };

  fetchDraftDecisions = (pageNumber = 1) => {
    draftDecisionsService
      .getAll(pageNumber, this.state.selectedArchiveYear)
      .then(jsonResponse => {
        this.setDraftDecisionState(jsonResponse);
      })
      .catch(error => console.log(error));
  };

  handleArchiveYearChange = event => {
    const selectedArchiveYear = event.target.value;
    this.setState({ selectedArchiveYear }, () => {
      this.fetchDraftDecisions(1);
    });
  };

  setDraftDecisionState = response => {
    let existingDraftDecisions = { ...this.state.existingDraftDecisions };
    let pagination = { ...this.state.pagination };
    existingDraftDecisions = response.draft_decisions;
    pagination = response.pagination;

    this.setState({ existingDraftDecisions });
    this.setState({ pagination });
  };

  updateField = event => {
    const field = event.target.name;
    const newDraftDecision = this.state.newDraftDecision;
    newDraftDecision[field] = event.target.value;

    this.setState({
      newDraftDecision
    });
  };

  onDropDocument = documents => {
    let newDraftDecision = { ...this.state.newDraftDecision };
    let reader = new FileReader();
    let self = this;

    reader.onload = function(upload) {
      newDraftDecision.document = documents[0];

      self.setState({ newDraftDecision });
      self.setState({ disabledDocument: true });
    };
    reader.readAsDataURL(documents[0]);
  };

  removeDocument = () => {
    let newDraftDecision = { ...this.state.newDraftDecision };
    newDraftDecision.document = null;

    this.setState({ newDraftDecision });
    this.setState({ disabledDocument: false });
  };

  resetForm = () => {
    let newDraftDecision = { ...this.state.newDraftDecision };
    newDraftDecision = {
      title: '',
      document: '',
      add_date: ''
    };

    this.setState({ newDraftDecision });
    this.setState({ disabledDocument: false });
  };

  handleFormSubmit = event => {
    event.preventDefault();
    const currentId = this.state.newDraftDecision.id;

    const headers = {
      Accept: 'application/json'
    };

    if (this.authentication.loggedIn()) {
      headers['Authorization'] = 'Bearer ' + this.authentication.getToken();
    }

    let url = `${process.env.REACT_APP_API_URL}/api/draft_decisions/`;
    let callMethod = 'POST';

    if (currentId) {
      url = `${process.env.REACT_APP_API_URL}/api/draft_decisions/${this.state.newDraftDecision.id}`;
      callMethod = 'PUT';
    }

    const formattedData = this.buildFormData();

    fetch(url, {
      method: callMethod,
      body: formattedData,
      headers
    })
      .then(this.handleErrors)
      .then(response => response.json())
      .then(jsonResponse => {
        this.resetForm();

        let existingDraftDecisions = this.state.existingDraftDecisions.slice();

        let index = existingDraftDecisions.findIndex(
          existingDraftDecisionDocument =>
            existingDraftDecisionDocument.id === jsonResponse.id
        );

        if (index !== -1) {
          existingDraftDecisions[index] = jsonResponse;
        } else {
          existingDraftDecisions.push(jsonResponse);
        }

        this.setState({ existingDraftDecisions });

        if (currentId) {
          this._notificationSystem.addNotification({
            message: 'Decizia a fost editata cu success.',
            level: 'success',
            position: 'tc'
          });
        } else {
          this._notificationSystem.addNotification({
            message: 'Decizia a fost adaugata cu success.',
            level: 'success',
            position: 'tc'
          });
        }
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  buildFormData() {
    let formData = new FormData();
    formData.append('draft_decision[title]', this.state.newDraftDecision.title);

    formData.append(
      'draft_decision[add_date]',
      this.state.newDraftDecision.add_date
    );

    if (this.state.newDraftDecision.document) {
      let document = this.state.newDraftDecision.document;
      appendAttachment(formData, `draft_decision[document]`, document);
    }

    return formData;
  }

  setDraftDecisionForEdit = newDraftDecisionDoc => {
    let newDraftDecision = { ...this.state.newDraftDecision };
    newDraftDecision = Object.assign({}, newDraftDecisionDoc);
    this.setState({ newDraftDecision });

    if (newDraftDecision.document.url) {
      this.setState({ disabledDocument: true });
    }
  };

  openDeleteDialog = id => {
    let deleteDraftDecision = { ...this.state.deleteDraftDecision };
    deleteDraftDecision = {
      openedDialog: true,
      deleteId: id
    };

    this.setState({ deleteDraftDecision });
  };

  closeDeleteDialog = () => {
    let deleteDraftDecision = { ...this.state.deleteDraftDecision };
    deleteDraftDecision = {
      openedDialog: false,
      deleteId: 0
    };

    this.setState({ deleteDraftDecision });
  };
  handleCheckBox = () => {
    let newDraftDecision = { ...this.state.newDraftDecision };
    newDraftDecision.public_consultation = !newDraftDecision.public_consultation;
    this.setState({
      newDraftDecision
    });
  };

  handleDelete = () => {
    draftDecisionsService
      .deleteDraftDecision(this.state.deleteDraftDecision.deleteId)
      .then(() => {
        let existingDraftDecisions = this.state.existingDraftDecisions.slice();
        existingDraftDecisions = existingDraftDecisions.filter(
          draftDecision =>
            draftDecision.id !== this.state.deleteDraftDecision.deleteId
        );
        this.setState({ existingDraftDecisions });

        this.closeDeleteDialog();

        this._notificationSystem.addNotification({
          message: 'Convocarea a fost stears cu success.',
          level: 'success',
          position: 'tc'
        });
      })
      .catch(error => {
        this._notificationSystem.addNotification({
          message:
            'A aparut o problema, faceti refresh la pagina sau contactati administratorul daca problema persista.',
          level: 'error',
          position: 'tc'
        });
      });
  };

  handleErrors = response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return response;
  };

  render() {
    return (
      <div className="admin-standard-page">
        <div className="admin-standard-page__title">
          <h3 className="admin-page__profile-title profile-title-specific">
            Administrație
          </h3>
          <h1 className="admin-switch-title default-title">
            Proiecte de hotarari
          </h1>
        </div>
        <div className="title-line" />
        <div className="admin-standard-page__content">
          <div className="admin-standard-page__create-project">
            <div className="card">
              <form className="admin-form" onSubmit={this.handleFormSubmit}>
                <h2 className="admin-form__title">
                  Adaugă un proiect de hotărâre nou
                </h2>

                <div className="admin-form__field">
                  <h4 className="label-title label-title-provisions">
                    Titlu proiect de hotărâre*
                  </h4>
                  <textarea
                    required
                    className="general-field title-field"
                    name="title"
                    onChange={this.updateField}
                    value={this.state.newDraftDecision.title}
                  />
                  <h4 className="label-title label-title-provisions">
                    Dată proiect de hotărâre*
                  </h4>
                  <input
                    required
                    className="general-field title-field"
                    name="add_date"
                    onChange={this.updateField}
                    value={this.state.newDraftDecision.add_date}
                    type="date"
                  />
                </div>
                <div className="admin-form__upload">
                  <h4 className="label-title label-title-provisions">
                    Document Proiect de Hotarare:
                  </h4>
                  <AttachmentField
                    onDrop={this.onDropDocument}
                    removeDocument={this.removeDocument}
                    disabledDocuments={this.state.disabledDocument}
                    document={this.state.newDraftDecision.document}
                    documentFilename={
                      this.state.newDraftDecision.document_filename
                    }
                    type="application/pdf"
                  />
                </div>
                <div className="consent">
                  <label>
                    <input
                      id="input-checkbox"
                      type="checkbox"
                      name="over5000"
                      checked={this.state.newDraftDecision.public_consultation}
                      onChange={this.handleCheckBox}
                    />
                  </label>
                  <h5>Proiect aflat in consultare publica</h5>
                </div>
                <div className="form-buttons">
                  <div className="admin-form__submit">
                    <button
                      type="submit"
                      className="submit-button general-button"
                    >
                      {this.state.newDraftDecision.id
                        ? 'Editeaza Proiect'
                        : 'Adauga Proiect'}
                    </button>
                  </div>
                  {Object.values(this.state.newDraftDecision) && (
                    <button
                      type="button"
                      className="general-button reset-button"
                      onClick={() => this.resetForm()}
                    >
                      Resetează câmpurile
                    </button>
                  )}
                </div>
              </form>
              <div className="admin-year-filter admin-year-filter--documents">
                <div className="admin-year-filter__control">
                  <h4 className="label-title label-title-provisions">
                    An arhivă
                  </h4>
                  <select
                    className="admin-year-filter__select"
                    value={this.state.selectedArchiveYear}
                    onChange={this.handleArchiveYearChange}
                  >
                    <option value="all">Toți anii</option>
                    {this.state.archiveYears.map(archiveYear => (
                      <option key={archiveYear.id} value={archiveYear.value}>
                        {archiveYear.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {this.state.existingDraftDecisions.length > 0 && (
            <div className="admin-standard-page__existing-items">
              <div className="card">
                <div className="existing-items">
                  <h2 className="existing-items-title label-title ">
                    Proiecte de hotarari existente
                  </h2>
                  <div className="existing-items__content">
                    {this.state.existingDraftDecisions.map(draftDecision => (
                      <div
                        className="existing-items__content-card"
                        key={draftDecision.id}
                      >
                        <div className="card-content provisions-title-content">
                          <h3 className="major-provisions-title">
                            {draftDecision.title}
                          </h3>
                        </div>
                        <div className="existing-items__actions-card">
                          <div
                            className="provisions-title-content"
                            onClick={() =>
                              this.setDraftDecisionForEdit(draftDecision)
                            }
                          >
                            <h4 className="action-title"> Editează</h4>
                          </div>

                          <div
                            className="provisions-title-content"
                            onClick={() =>
                              this.openDeleteDialog(draftDecision.id)
                            }
                          >
                            <h4 className="action-title delete-button">
                              {' '}
                              Șterge
                            </h4>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <DeletePUGCertificates
                    opened={this.state.deleteDraftDecision.openedDialog}
                    handleClose={this.closeDeleteDialog}
                    handleDelete={this.handleDelete}
                    headline="Sunteti sigur ca doriti sa stergeti aceast proiect de hotarare?"
                    aditionalText="Dupa stergere, proiectul de hotarare nu va mai putea fi recuperat."
                  />
                </div>
                {this.state.pagination.last_page > 1 && (
                  <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pagination.last_page}
                    marginPagesDisplayed={1}
                    pageRangeDisplayed={2}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                  />
                )}
              </div>
            </div>
          )}
        </div>
        <NotificationSystem
          ref="notificationSystem"
          style={NotificationSystemStyle}
        />
      </div>
    );
  }
}

export default AdminDraftDecisions;
